import { encodeURLValues } from '@/lib/url';
import { getSentinelUrl } from '@/api/sentinel';
import { initOAuthLogin } from '@/lib/oauth-redirect';

export const initSamlLogin = ({ email, slug = null, reauth = false }) => {
  const params = { email, flow: 'popup' };
  if (slug !== null && slug !== undefined && slug !== '') {
    params.slug = slug;
  }
  if (reauth) {
    params.reauth = '1';
  }
  return initOAuthLogin(getSentinelUrl(`/saml/login?${encodeURLValues(params)}`));
};

export const decodeSamlCandidates = (encoded) => {
  if (typeof encoded !== 'string' || encoded === '') {
    return [];
  }
  try {
    const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    const parsed = JSON.parse(new TextDecoder().decode(bytes));
    return Array.isArray(parsed) ? parsed.filter((candidate) => candidate.slug) : [];
  } catch {
    return [];
  }
};
